import api from "../../components/services/api";
import { useParams } from "react-router";
import { useState } from "react";
import { useEffect } from "react";
import moment from "moment";
import "./SaleOrder.css";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";

export default function ContainerManagement() {
  let { id } = useParams();
  const [data, setData] = useState();
  const [dataPickup, setDataPickup] = useState([]);
  const [dataReturn, setDataReturn] = useState([]);
  const [groupData, setGroupData] = useState([
    {
      GroupId: "G001",
      GroupName: "รถ",
      GroupNo: "00001",
      Status: true,
      CreateID: null,
      CreateDate: "2022-12-28T05:00:15.567Z",
      ModifiedID: null,
      ModifiedDate: "2022-12-28T05:00:15.567Z",
    },
    {
      GroupId: "G002",
      GroupName: "รถไฟ",
      GroupNo: "00002",
      Status: true,
      CreateID: null,
      CreateDate: "2022-12-28T05:00:15.595Z",
      ModifiedID: null,
      ModifiedDate: "2022-12-28T05:00:15.595Z",
    },
    {
      GroupId: "G003",
      GroupName: "เรือ",
      GroupNo: "00003",
      Status: true,
      CreateID: null,
      CreateDate: "2022-12-28T05:00:15.621Z",
      ModifiedID: null,
      ModifiedDate: "2022-12-28T05:00:15.621Z",
    },
  ]);
  function useQuery() {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
  }
  let query = useQuery();

  const getdata = async () => {
    const res = await api.get(`api/containermanagement/detail/${id}`);
    const data = res?.data;
    setData(data);
    setDataPickup(
      data?.ContainerList?.filter(
        (x) => x?.PickupDate && x?.PickupTruckNo && x?.PickupTime
      )
    );
    setDataReturn(
      data?.ContainerList?.filter(
        (x) => x?.ReturnDate && x?.ReturnTime && x?.ReturnTruckNo
      )
    );
  };

  const getMasterGroup = async () => {
    const res = await api.get(`api/master/group`);
    const data = await res.data;
    if (res.meta.status === true) {
      setGroupData(data.data);
    }
  };
  useEffect(() => {
    getdata();
    // getMasterGroup()
  }, []);

  // const pageCount = 1
  const pageCountPickup = Math.ceil(dataPickup?.length / 4);
  const pageCountReturn = Math.ceil(dataReturn?.length / 4);
  const pageCount =
    pageCountPickup > pageCountReturn ? pageCountPickup : pageCountReturn;
  const rows = [];
  for (let pageIndex = 0; pageIndex < pageCount; pageIndex++) {
    rows.push(
      <>
        <page>
          <div class="header">
            <img src="/images/logo2.png" class="logo" />
            <div className="header_title">
              <h3>SRITRANG LOGISTIC COMPANY LIMITED</h3>
              <h5>บริษัท ศรีตรังโลจิสติกส์ จำกัด </h5>
            </div>
          </div>
          <div class="titleR">
            <h3>Container Management</h3>
          </div>
          <div class="content">
            <div className="rowR">
              <p className="header_p">Sale Order No. </p>
              <p> {data?.SaleOrderNo || "-"}</p>
            </div>
            <div className="rowR"></div>
            <div className="rowR">
              <p className="header_p">Shipper Ref No.</p>
              <p> {data?.ShipperRefNo || "-"}</p>
            </div>
            <div className="rowR"></div>
            <div className="rowR">
              <p className="header_p">Booking No.</p>
              <p> {data?.BookingNo || "-"}</p>
            </div>
            <div className="rowR"></div>
            <div class="rowR sub">
              <p className="header_p">Quantity </p>
              <p>{data?.Quantity} </p>
            </div>
            <div class="rowR sub">
              <p className="header_p">Size </p>
              <p> {data?.Size}</p>
            </div>
            <div className="rowR"></div>
            <div className="rowR">
              <p className="header_p">Gender </p>
              <p>{data?.ContainerGender || "-"}</p>
            </div>
            <div className="rowR"></div>
            <div style={{ marginBottom: "30px" }}></div>
            <div className="rowR">
              <p className="header_p">Port of Loading </p>
              <p>{data?.InboundGateOut || "-"} </p>
            </div>
            <div className="rowR">
              <p className="header_p">ETD </p>
              <p>
                {data?.ETDPOLDate
                  ? moment(data?.ETDPOLDate).format("DD/MM/YYYY")
                  : "-"}{" "}
              </p>
            </div>

            <div class="rowR">
              <p className="header_p">Port of Discharge </p>
              <p> {data?.OutboundGateOut || "-"}</p>
            </div>
            <div class="rowR">
              <p className="header_p">ETA</p>
              <p>
                {" "}
                {data?.ETAPODDate
                  ? moment(data?.ETAPODDate).format("DD/MM/YYYY")
                  : "-"}
              </p>
            </div>

            <div class="rowR">
              <p className="header_p">VOY IN </p>
              <p> {data?.InboundVoyNo || ""}</p>
            </div>
            <div class="rowR"></div>
          </div>
          <div
            class="content_center"
            style={
              {
                // marginTop: "-10px"
              }
            }
          >
            <div class="rowR first" style={{ flexBasis: "40%" }}>
              <p className="header_p">Container Status </p>
              <p>{data?.ContainerStockType || "-"}</p>
            </div>
            <div class="rowR">
              <p className="header_p">Grade</p>
              <p>{data?.ContainerGrade || "-"}</p>
            </div>
            <div class="rowR">
              <p className="header_p">Plastic Sheet</p>
              <p>{data?.ContainerApplyPlasticSheet ? "yes" : "no"}</p>
            </div>
            <div class="rowR first"></div>
          </div>
          <div class="content">
            <div className="rowR">
              <p className="header_p">Stuffing Plan </p>
              <p> </p>
            </div>
            <div className="rowR"></div>
            <div className="rowR">
              <p className="header_p">Pick-up Date </p>
              <div style={{ display: "flex" }}>
                {data?.StuffingPlan?.map((x, i) => (
                  <p style={{whiteSpace:"nowrap"}}>{moment(x?.PickupDate).format("DD/MM/yyyy")}</p>
                ))}
              </div>
            </div>
            <div className="rowR"></div>
            <div className="rowR">
              <p className="header_p">Factory </p>
              <div
              //  style={{ display: "flex" }}
               >
                {data?.StuffingPlan?.map((x, i) => (
                  <p style={{whiteSpace:"nowrap"}}>{x?.FactoryName}</p>
                ))}
              </div>
            </div>
            <div className="rowR"></div>
            <div className="rowR">
              <p className="header_p">Return Date </p>
              <div style={{ display: "flex" }}>
                {data?.StuffingPlan?.map((x, i) => (
                  <p style={{whiteSpace:"nowrap"}}>{moment(x?.ReturnDate).format("DD/MM/yyyy")}</p>
                ))}
              </div>
            </div>
            <div className="rowR"></div>
          </div>
          <div class="content">
            <div class="rowR">
              <p className="header_p" style={{ flexBasis: "50%" }}>
                Booking Information
              </p>
              <p></p>
            </div>
            <div className="rowR"></div>
            <div class="rowR">
              <p className="header_p">Port of Loading</p>
              <p>{data?.POLLocationName || "-"}</p>
            </div>
            <div class="rowR">
              <p className="header_p">ETD</p>
              <p>
                {" "}
                {moment(data?.ETD).format("DD/MM/yyyy")} {data?.ETDTime}
              </p>
            </div>
            <div class="rowR">
              <p className="header_p">Port of Discharge</p>
              <p>{data?.PODLocationName || "-"}</p>
            </div>
            <div class="rowR">
              <p className="header_p">ETA</p>
              <p>
                {moment(data?.ETA).format("DD/MM/yyyy")} {data?.ETATime}
              </p>
            </div>
            <div class="rowR">
              <p className="header_p">Vessle</p>
              <p>{data?.IntendedVessel || "-"}</p>
            </div>
          </div>
          <div class="content" style={{ marginBottom: "0px" }}>
            <h5 style={{ marginBottom: "0px" }}>
              Truck pick-up {data?.InboundContainerGender || "Empty"} Container
            </h5>
          </div>
          <div class="containerR">
            <table border="1" cellpadding="10" cellspacing="0">
              <tr style={{ border: "1px solid" }}>
                <th style={{ border: "1px solid" }} class="text-center">
                  No.
                </th>
                <th style={{ border: "1px solid" }}>Container Number</th>
                <th style={{ border: "1px solid" }} class="text-center">
                  Truck No.
                </th>
                <th style={{ border: "1px solid" }} class="text-center">
                  Date
                </th>
                <th style={{ border: "1px solid" }} class="text-center">
                  Time
                </th>
              </tr>

              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }} align="center">
                  {pageIndex * 4 + 1}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[0]
                      ?.ContainerNo
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {
                    dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[0]
                      ?.PickupTruckNo
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[0]
                    ?.PickupDate &&
                    moment(
                      dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[0]
                        ?.PickupDate
                    ).format("DD/MM/YYYY")}
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {
                    dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[0]
                      ?.PickupTime
                  }
                </td>
              </tr>
              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }} align="center">
                  {pageIndex * 4 + 2}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[1]
                      ?.ContainerNo
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {
                    dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[1]
                      ?.PickupTruckNo
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[1]
                    ?.PickupDate &&
                    moment(
                      dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[1]
                        ?.PickupDate
                    ).format("DD/MM/YYYY")}
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {
                    dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[1]
                      ?.PickupTime
                  }
                </td>
              </tr>
              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }} align="center">
                  {pageIndex * 4 + 3}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[2]
                      ?.ContainerNo
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {
                    dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[2]
                      ?.PickupTruckNo
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[2]
                    ?.PickupDate &&
                    moment(
                      dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[2]
                        ?.PickupDate
                    ).format("DD/MM/YYYY")}
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {
                    dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[2]
                      ?.PickupTime
                  }
                </td>
              </tr>
              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }} align="center">
                  {pageIndex * 4 + 4}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[3]
                      ?.ContainerNo
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {
                    dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[3]
                      ?.PickupTruckNo
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[3]
                    ?.PickupDate &&
                    moment(
                      dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[3]
                        ?.PickupDate
                    ).format("DD/MM/YYYY")}
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {
                    dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[3]
                      ?.PickupTime
                  }
                </td>
              </tr>
            </table>
          </div>
          <div class="content" style={{ marginBottom: "0px" }}>
            <h5 style={{ marginBottom: "0px" }}>
              Truck return {data?.InboundContainerGender === "Laden" ? "Empty" : "Laden"} Container
            </h5>
          </div>
          <div class="containerR">
            <table border="1" cellpadding="10" cellspacing="0">
              <tr style={{ border: "1px solid" }}>
                <th style={{ border: "1px solid" }} class="text-center">
                  No.
                </th>
                <th style={{ border: "1px solid" }}>Container Number</th>
                <th style={{ border: "1px solid" }} class="text-center">
                  Truck No.
                </th>
                <th style={{ border: "1px solid" }} class="text-center">
                  Date
                </th>
                <th style={{ border: "1px solid" }} class="text-center">
                  Time
                </th>
                <th style={{ border: "1px solid" }} class="text-center">
                  Seal Shipper
                </th>
              </tr>

              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }} align="center">
                  {pageIndex * 4 + 1}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    dataReturn?.slice(pageIndex * 4, pageIndex * 4 + 4)[0]
                      ?.ContainerNo
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {
                    dataReturn?.slice(pageIndex * 4, pageIndex * 4 + 4)[0]
                      ?.ReturnTruckNo
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {dataReturn?.slice(pageIndex * 4, pageIndex * 4 + 4)[0]
                    ?.ReturnDate &&
                    moment(
                      dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[0]
                        ?.PickupDate
                    ).format("DD/MM/YYYY")}
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {
                    dataReturn?.slice(pageIndex * 4, pageIndex * 4 + 4)[0]
                      ?.ReturnTime
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {
                    dataReturn?.slice(pageIndex * 4, pageIndex * 4 + 4)[0]
                      ?.SealShipperNo
                  }
                </td>
              </tr>

              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }} align="center">
                  {pageIndex * 4 + 2}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    dataReturn?.slice(pageIndex * 4, pageIndex * 4 + 4)[1]
                      ?.ContainerNo
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {
                    dataReturn?.slice(pageIndex * 4, pageIndex * 4 + 4)[1]
                      ?.ReturnTruckNo
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {dataReturn?.slice(pageIndex * 4, pageIndex * 4 + 4)[1]
                    ?.ReturnDate &&
                    moment(
                      dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[1]
                        ?.PickupDate
                    ).format("DD/MM/YYYY")}
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {
                    dataReturn?.slice(pageIndex * 4, pageIndex * 4 + 4)[1]
                      ?.ReturnTime
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {
                    dataReturn?.slice(pageIndex * 4, pageIndex * 4 + 4)[1]
                      ?.SealShipperNo
                  }
                </td>
              </tr>
              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }} align="center">
                  {pageIndex * 4 + 3}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    dataReturn?.slice(pageIndex * 4, pageIndex * 4 + 4)[2]
                      ?.ContainerNo
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {
                    dataReturn?.slice(pageIndex * 4, pageIndex * 4 + 4)[2]
                      ?.ReturnTruckNo
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {dataReturn?.slice(pageIndex * 4, pageIndex * 4 + 4)[2]
                    ?.ReturnDate &&
                    moment(
                      dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[2]
                        ?.PickupDate
                    ).format("DD/MM/YYYY")}
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {
                    dataReturn?.slice(pageIndex * 4, pageIndex * 4 + 4)[2]
                      ?.ReturnTime
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {
                    dataReturn?.slice(pageIndex * 4, pageIndex * 4 + 4)[2]
                      ?.SealShipperNo
                  }
                </td>
              </tr>
              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }} align="center">
                  {pageIndex * 4 + 4}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    dataReturn?.slice(pageIndex * 4, pageIndex * 4 + 4)[3]
                      ?.ContainerNo
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {
                    dataReturn?.slice(pageIndex * 4, pageIndex * 4 + 4)[3]
                      ?.ReturnTruckNo
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {dataReturn?.slice(pageIndex * 4, pageIndex * 4 + 4)[3]
                    ?.ReturnDate &&
                    moment(
                      dataPickup?.slice(pageIndex * 4, pageIndex * 4 + 4)[3]
                        ?.PickupDate
                    ).format("DD/MM/YYYY")}
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {
                    dataReturn?.slice(pageIndex * 4, pageIndex * 4 + 4)[3]
                      ?.ReturnTime
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {
                    dataReturn?.slice(pageIndex * 4, pageIndex * 4 + 4)[3]
                      ?.SealShipperNo
                  }
                </td>
              </tr>
            </table>
          </div>
        </page>
      </>
    );
  }
  return <>{rows}</>;
}
